<template>
  <div class="form-wrap">
    <template>
      <form id="mainForm" class="project-form" >
        <input type="hidden" v-model="renderCars">
        <section class="project-details">
          <table class="ses-project">
            <tr class="ses-row">
              <td class="ses-label"><strong>Company Name</strong></td>
              <td>
                <input ref="company_namee" v-model="survey.company_name" type="text" maxlength="100" required @blur="handleSurveyDetail('company_name')">
              </td>
              <td class="ses-label"><strong>Quote Number</strong></td>
              <td>
                <input ref="quote_numberr" v-model="survey.quote_number" type="text" maxlength="32" required>
              </td>
            </tr>
            <tr class="ses-row">
              <td class="ses-label"><strong>Project Name</strong></td>
              <td>
                <input ref="project_namee" v-model="survey.project_name" type="text" maxlength="100" required @blur="handleSurveyDetail('project_name')">
              </td>
              <template v-if="survey.id">
                <td class="ses-label"><strong>Date Created</strong></td>
                <td class="text-center">{{ survey.created_at }}</td>
              </template>
              <template v-else>
                <td class="ses-label"><strong>Current Date</strong></td>
                <td class="text-center">{{ survey.current_date }}</td>
              </template>
            </tr>
            <tr class="ses-row">
              <td class="ses-label">Number of Cars <small>(range: 1-20)</small></td>
              <td>
                <input ref="num_carss" v-model="num_cars" type="number" required @keyup="setCars" @blur="setCars">
              </td>
            </tr>
            <tr class="ses-row">
              <td class="ses-label">Car ID Number(s)</td>
              <td colspan="3" class="ses-flex-wrap">
                <div class="ses-flex">
                  <div class="ses-col" v-for="(car, cn) in drawingParams" :key="`caridid${car.id}`">
                    <input
                      :ref="`car_id_numberr`"
                      v-model="car.car_id_number"
                      :data-cn="cn"
                      type="text"
                      class="col"
                      placeholder="Car #"
                      required
                      @blur="handleIdNumber($event, cn)">
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </section>
        <section class="project-section project-section-1">
          <div class="sform">
            <h2 class="proj-s1">3D Parameters</h2>
            <div class="top-scroll">
                <div class="top-scroll-body"></div>
            </div>
            <div class="proj-labels">
              <div class="proj-section1 proj-group">
                <div class="proj-s1" v-if="drawingParams[1]"><label> Copy From</label></div>
                 <div class="proj-s1"><label> Car ID Number </label></div>
                <div v-for="label in parameterLabels" :key="label.id" class="proj-s1" :class="{ 'model-param-label': label.label_key === 'MODEL'}">
                  <label> {{ label.label }} </label>
                </div>
              </div>
            </div>
            <div class="proj-cars">
              <div class="proj-car" v-for="(car, cn) in drawingParams" :key="`carid${car.id}`">
                <div class="proj-section1 proj-group">
                  <div class="proj-s1" v-if="drawingParams[1]">
                    <select v-model="car.copier" @change="copyInput(car.copier, cn)">
                      <template v-for="(ccar, ccn) in drawingParams">
                        <option v-if="cn != ccn" :value="ccn" :key="`ccarid${ccar.id}`">Car #{{ ccar.car_id_number }}</option>
                      </template>
                    </select>
                  </div>
                  <div class="proj-s1"><input type="text" v-model="car.car_id_number" disabled></div>
                  <div v-for="labelInput in parameterLabels" :key="labelInput.id" class="proj-s1" :class="{ 'model-param': labelInput.label_key === 'MODEL' }">
                    <template v-if="labelInput.label_key === 'MODEL'">
                      <select-machine
                        :ref="`select_machine_${labelInput.id}`"
                        :options="labelInput.options"
                        :selected="car[`${labelInput.label_key}`]"
                        :select-ref="`machine_select_${labelInput.label_key}_${cn}`"
                        :search-key="car.search"
                        name="option"
                        option-key="id"
                        option-value="option"
                        @clicked="handleClickedMachine($event, car, cn)"/>
                    </template>
                    <template v-else-if="labelInput.input_type === 'text'">
                      <input
                        :ref="`${labelInput.label_key}${cn}`"
                        v-model="car[`${labelInput.label_key}`]"
                        :required="handleIsRequired(labelInput.required, car, labelInput.label_key)"
                        :disabled="handleIsDisabled(labelInput.autofill, car, labelInput.label_key)"
                        type="text"
                        @blur="handleChangeSelect(cn, car, $event, labelInput.label_key)">
                    </template>
                    <template v-else-if="labelInput.input_type === 'dropdown'">
                      <select
                        :ref="`${labelInput.label_key}${cn}`"
                        v-model="car[`${labelInput.label_key}`]"
                        :required="parseInt(labelInput.required) > 0"
                        :disabled="handleIsDisabled(labelInput.autofill, car, labelInput.label_key)"
                        @change="handleChangeSelect(cn, car, $event, labelInput.label_key)">
                        <template v-if="labelInput.label_key === 'RG' || labelInput.label_key === 'still_rotation'">
                          <option></option>
                        </template>
                        <template v-if="labelInput.label_key !== 'DrawingNum'">
                          <option v-for="option in labelInput.options" :key="option.id" :value="option.option">
                            <template v-if="labelInput.label_key !== 'short_iso_pads'">
                              {{ option.option }}
                            </template>
                            <template v-else>
                              {{ (parseInt(option.option) === 1) ? 'SRTW' : 'Regular pads' }}
                            </template>
                          </option>
                        </template>
                        <template v-else>
                          <optgroup label="System Data">
                            <option
                              v-for="option in labelInput.options.system"
                              :key="option.id"
                              :id="`sdata-${option.id}`"
                              :value="`${option.system_name}--${option.id}`">{{ option.option }}</option>
                          </optgroup>
                          <optgroup label="Special System Data">
                            <option
                              v-for="option in labelInput.options.special"
                              :key="option.id"
                              :id="`spsdata-${option.id}`"
                              :value="`${option.system_name}--${option.id}`">{{ option.option }}</option>
                          </optgroup>
                        </template>
                      </select>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </form>
      <div class="proj-controls">
        <span>
          <template v-if="survey.id">
            <a :disabled="isSavingCopy" class="btn btn-black btn-custom-height" @click="handleSave">
              <template v-if="isSavingCopy"><span class="fa fa-spinner fa-pulse"></span> Updating Copy...</template>
              <template v-else>Update Copy</template>
            </a>
          </template>
          <template v-else>
            <a :disabled="isSavingCopy" class="btn btn-black btn-custom-height" @click="handleSave">
              <template v-if="isSavingCopy"><span class="fa fa-spinner fa-pulse"></span> Saving Copy...</template>
              <template v-else>Save Copy</template>
            </a>
          </template>
        </span>
    </div>
    </template>
  </div>
</template>
<script>
import { DuplicateDrawing } from '../../api/drawing/duplicate'
import SelectMachine from './SelectMachine.vue'
import { ParameterLabel } from '../../api/drawing/parameterLabel'
export default {
  name: 'CopyDrawing',
  components: { SelectMachine },
  data() {
    return {
      survey: {
        project_name: '',
        company_name: '',
        quote_number: ''
      },
      drawingParams: [],
      isDetailsLoading: false,
      isSavingCopy: false,
      num_cars: 1,
      renderCars: 1,
      parameterLabels: [],
      machineData: [],
      specialSystemData: [],
      systemData: [],
      itemWeights: []
    }
  },
  created() {
    this.getLabels()
    if ('editId' in this.$route.params) {
      this.getCopiedDrawings()
    } else if (this.$route.params.id == 'new') {
      this.handleNewDrawing()
    } else {
      this.getOriginalProjectDrawing()
    }
  },
  methods: {
    getLabels() {
      ParameterLabel().then(response => {
        this.parameterLabels = response.data.labels
        this.machineData = response.data.machine_data
        this.specialSystemData = response.data.special_system_data
        this.systemData = response.data.system_data
        this.itemWeights = response.data.items
      })
      .catch(error => {
        console.log(error)
      })
    },
    setCars() {
      if ( this.num_cars != '' && this.num_cars < 1 ) this.num_cars = 1
      if ( this.num_cars > 20 ) this.num_cars = 20
      let toDup = {},
        cn = 0,
        num_cars = parseInt(this.num_cars),
        carnum = this.drawingParams ? this.drawingParams.length : 1
      for (cn = carnum; cn < num_cars; cn++) {
        toDup[cn] = {
          ...{},
          ...{
            car_id_number: cn + 1,
            car_num: cn + 1,
            PN: this.survey.project_name + ' - ' + (cn + 1),
            CN: this.survey.company_name,
            export_step: 'True',
            rev: 1,
            search: ''
          }
        }
        this.drawingParams[cn] = toDup[cn]
      }
      if (num_cars < carnum) {
        this.drawingParams = this.drawingParams.filter(x => x.car_num <= num_cars)
        .sort((a, b) => a.car_num - b.car_num)
      }
      this.renderCars++
    },
    getOriginalProjectDrawing() {
      this.isDetailsLoading = true
      const params = { addId: this.$route.params.id }
      DuplicateDrawing(params, 'get', 'original-drawings').then(response => {
        this.drawingParams = response.data.drawings
        if (response.data.drawings.length < 1) {
           this.num_cars = 1
           this.setCars()
           this.renderCars++
        } else {
          this.num_cars = response.data.drawings.length
        }
        this.survey = response.data.details
        this.getNow()
        this.isDetailsLoading = false
      })
      .catch(error => {
        console.log(error)
        this.isDetailsLoading = false
      })
    },
    getCopiedDrawings() {
      this.isDetailsLoading = true
      const params = { editId: this.$route.params.editId }
      DuplicateDrawing(params, 'get', 'copied-drawings').then(response => {
        this.drawingParams = response.data.drawings
        this.num_cars = response.data.drawings.length
        this.survey = response.data.details
        this.isDetailsLoading = false
      })
      .catch(error => {
        console.log(error)
        this.isDetailsLoading = false
      })
    },
    checkData() {
      let mpnCheck = false
      for (let dp in this.drawingParams) {
        const tempm = this.drawingParams[dp].MODEL
        if (
          tempm === null ||
          tempm === undefined ||
          tempm === '' ||
          (tempm.trim && tempm.trim() == '')
        ) {
          alert('Please fill Machine Part Number data.');
          mpnCheck = true
          break;
        }
      }
      if (mpnCheck) return false
      var hasEmpty = false,
          firstEl = false,
          item = false;
      for(var i in this.$refs) {
        const _el = this.$refs[i];
        if ( Array.isArray(_el) ) {
          for (var x in _el) {
            item = _el[x];
            if ( item && item.required && !item.disabled && (item.value == '' || item.value == undefined || (item.value.trim && item.value.trim() == '')) ) {
              hasEmpty = true;
              if ( !firstEl ) {
                firstEl = item;
                break;
              }
            }
          }
        } else {
          item = _el;
          if ( item && item.required && !item.disabled && (item.value == '' || item.value == undefined || (item.value.trim && item.value.trim() == '')) ) {
            hasEmpty = true;
            if ( !firstEl ) {
              firstEl = item;
              break;
            }
          }
        }
      }
      Array.from(document.querySelectorAll('.has-error')).forEach(function(el) {
        el.classList.remove('has-error');
      });
      if ( hasEmpty ) {
        alert('Please fill all required data.');
        firstEl.focus();
        firstEl.classList.add('has-error');
        return false
      }
      return true
    },
    handleSave() {
      if (!this.checkData()) return false
      this.isSavingCopy = true
      this.survey.survey_id = this.$route.params.id
      let params = { details: this.survey, drawings: JSON.stringify(this.drawingParams) }
      const action = this.survey.id ? 'put' : 'post'
      if (action === 'put') {
        params.id = this.survey.id
      }
      DuplicateDrawing(params, action).then(() => {
        this.$router.push({ path: '/drawings' })
        this.isSavingCopy = false
      }).catch(error => {
        console.log(error)
        this.isSavingCopy = false
      })
    },
    getNow(){
      const today = new Date()
      const m = today.getMonth() + 1
      const month = m < 10 ? '0' + m : m
      const d = today.getDate()
      const day = d < 10 ? '0' + d : d
      const date = today.getFullYear() + '-' + month + '-' + day
      
      this.survey.current_date = date
    },
    copyInput(from, to){
      const temp = Object.assign({}, this.drawingParams[from])
      temp.car_id_number = this.drawingParams[to].car_id_number
      temp.car_num = this.drawingParams[to].car_num
      temp.quantity_of_car = 1
      const ncar = {
        ...{},
        ...temp
      }
      this.drawingParams[to] = ncar
      this.renderCars++
    },
    handleNewDrawing() {
      this.drawingParams[0] = {
        car_num: 1,
        export_step: 'True',
        rev: 1
      }
      this.getNow()
    },
    handleIdNumber(value, cn) {
      this.drawingParams[cn].car_id_number = value.target.value
      this.drawingParams[cn].PN = this.survey.project_name + ' - ' + value.target.value
      this.renderCars++
    },
    handleIsRequired(defaultReq, car, key) {
      if (key === 'YS' && car.EDS === 'YES') {
        defaultReq = 1
      }
      return parseInt(defaultReq) > 0
    },
    handleIsDisabled(autofill, car, key) {
      switch(key) {
        case 'x3': {
          if ((car.dor === 'C' || car.dor === 'D') && car.angled_bedplate === 'Yes') {
            autofill = 0
          } else {
            autofill = 1
          }
          break
        }
        case 'dor':
        case 'x1':
        case 'x2': {
          if (car.angled_bedplate !== 'Yes') {
            autofill = 1
          }
          break
        }
      }
      return parseInt(autofill) > 0
    },
    handleSurveyDetail(key) {
      for (let i = 0; i < this.drawingParams.length; i++) {
        let _car = this.drawingParams[i];
        switch(key) {
          case 'company_name': {
            _car.CN = this.survey[key]
            break
          }
          case 'project_name': {
            _car.PN = this.survey[key] + ' - ' + _car.car_id_number
            break
          }
        }
      }
      this.renderCars++
    },
    handleChangeSelect(cn, car, event, key) {
      const currentValue = event.target.value
      const currentSelectedIndex = ('selectedIndex' in event.target) ? event.target.selectedIndex : -1
      let _car = this.drawingParams[cn]
      switch(key) {
        case 'MODEL': {
          let currentMachineData = this.machineData[currentSelectedIndex]
          const isBetaNotApplicable = currentMachineData.Beta == 'NA'
          const betaPostFix = (isBetaNotApplicable) ? ')' : `~${currentMachineData.Beta}°)`
          const groovePrefix = `${currentMachineData.Groove_NO} Grooves (`
          const pitchPostFix = `*${currentMachineData.Rope_Size}*${currentMachineData.Pitch_in}"Pitch`
          const proper = `${groovePrefix}${currentMachineData.Groove_Shape}${currentMachineData.Gamma}${betaPostFix}${pitchPostFix}`
          _car.SHEAVE_GROOVE = proper

          _car.pitch_in = currentMachineData.Pitch_in
          _car.eb = currentMachineData.EB
          _car.eb_pn = this.handleNotApplicableOrNullValue(currentMachineData.EB_PN)
          _car.sheave_pn = this.handleNotApplicableOrNullValue(currentMachineData.Sheave_PN)
          _car.rope_size = currentMachineData.Rope_Size
          _car.enc_pn = currentMachineData.ENC_PN
          _car.Gear = (currentMachineData.Gear === 'FALSE') ? 'Gearless' : 'Geared'
          _car.MT = currentMachineData.Model
          _car.motor_pn = this.handleNotApplicableOrNullValue(currentMachineData.Motor_PN)
          _car.SW_Model = currentMachineData.SW_Model
          _car.machineid = currentMachineData.id
          _car.BOM_PART_1 = currentMachineData.Machine_Part_Number
          const weightIndex = this.itemWeights.findIndex(x => x.item.toLowerCase() == currentValue.toLowerCase())
          if (weightIndex > -1) _car.BOM_WEIGHT_1 = this.itemWeights[weightIndex].weight
          this.renderCars++
          break
        }
        case 'DrawingNum': {
          let currentSystemData = {}
          const dataSystemLength = this.systemData.length
          if ((currentSelectedIndex + 1) > dataSystemLength) {
            const myIndex = currentSelectedIndex - dataSystemLength
            currentSystemData = Object.assign({}, this.specialSystemData[myIndex])
            _car.bedplate_pn = currentSystemData.Base_Bedplate
            _car.BOM_PART_2 = currentSystemData.Base_Bedplate
            _car.sysid = null
            _car.spsysid = currentSystemData.id
            let spweightIndex = this.itemWeights.findIndex(x => x.item.toLowerCase() == currentSystemData.Base_Bedplate.toLowerCase())
            if (spweightIndex > -1) _car.BOM_WEIGHT_2 = this.itemWeights[spweightIndex].weight
          } else {
            currentSystemData = currentSystemData = Object.assign({}, this.systemData[currentSelectedIndex])
            _car.bedplate_pn = currentSystemData.BedPlate
            _car.BOM_PART_2 = currentSystemData.BedPlate
            _car.spsysid = null
            _car.sysid = currentSystemData.id
            let sweightIndex = this.itemWeights.findIndex(x => x.item.toLowerCase() == currentSystemData.BedPlate.toLowerCase())
            if (sweightIndex > -1) _car.BOM_WEIGHT_2 = this.itemWeights[sweightIndex].weight
          }
          _car.Deflector_Dia = this.handleNotApplicableOrNullValue(currentSystemData.Deflector_Dia)
          _car.BT = currentSystemData.Hi_Lo
          if (_car.BT === 'Lo') {
            if (_car.Deflector_Dia == null || _car.Deflector_Dia == '') {
              _car.deflector_bedplate = null
            } else {
              const MSV_OD = this.machineData[this.machineData.findIndex(x => x.Machine_Part_Number.toLowerCase() == _car['MODEL'].toLowerCase())].MSV_OD
              const defbed = ((((parseFloat(_car.RDD) - (parseFloat(MSV_OD) / 2)) - (parseFloat(_car.Deflector_Dia) / 2))) * 25.4) + parseFloat(currentSystemData.Deflector_cen_to_bedplate_cen)
              _car.deflector_bedplate = Math.round((defbed + Number.EPSILON) * 100) / 100
            }
          } else if (_car.BT === 'Hi') {
            _car.deflector_bedplate = this.handleNotApplicableOrNullValue(currentSystemData.Deflector_cen_to_bedplate_cen)
          }
          _car.Cbeam_Z1 = this.handleCbeam(_car, currentSystemData, 'cbeamz1')
          _car.Cbeam_Z2 = this.handleCbeam(_car, currentSystemData, 'cbeamz2')
          _car.Cbeam_Z1_Wall = _car.Cbeam_Z1
          _car.Cbeam_Z2_Wall = _car.Cbeam_Z2
          _car.BOM_PART_6 = this.handleNotApplicableOrNullValue(currentSystemData.Riser)
          _car.BOM_PART_7 = this.handleNotApplicableOrNullValue(currentSystemData['SHPLT-CAR'])
          _car.BOM_PART_8 = this.handleNotApplicableOrNullValue(currentSystemData['SHPLT-CWT'])
          _car.BOM_PART_9 = this.handleNotApplicableOrNullValue(currentSystemData.Retainer)
          currentSystemData.Deflector = (currentSystemData.Deflector) ? currentSystemData.Deflector.replace(/\\/g, '') : null
          currentSystemData.Deflector_Dia = (currentSystemData.Deflector_Dia) ? currentSystemData.Deflector_Dia : null
          _car.deflector_pn = this.handleNotApplicableOrNullValue(currentSystemData.Deflector)
          _car.BOM_PART_3 = _car.deflector_pn
          const tempd = _car.deflector_pn
          let weightIndex = (tempd) ? this.itemWeights.findIndex(x => x.item.toLowerCase() == tempd.toLowerCase()) : -1
          if (weightIndex > -1) _car.BOM_WEIGHT_3 = this.itemWeights[weightIndex].weight
          weightIndex = (_car.BOM_PART_6) ? this.itemWeights.findIndex(x => x.item.toLowerCase() == currentSystemData.Riser.toLowerCase()) : -1
          if (weightIndex > -1) _car.BOM_WEIGHT_6 = this.itemWeights[weightIndex].weight
          if (_car.BOM_PART_6 == null) _car.BOM_WEIGHT_6 = null
          weightIndex = (_car.BOM_PART_7) ? this.itemWeights.findIndex(x => x.item.toLowerCase() == currentSystemData['SHPLT-CAR'].toLowerCase()) : -1
          if (weightIndex > -1) _car.BOM_WEIGHT_7 = this.itemWeights[weightIndex].weight
          if (_car.BOM_PART_7 == null) _car.BOM_WEIGHT_7 = null
          weightIndex = (_car.BOM_PART_8) ? this.itemWeights.findIndex(x => x.item.toLowerCase() == currentSystemData['SHPLT-CWT'].toLowerCase()) : -1
          if (weightIndex > -1) _car.BOM_WEIGHT_8 = this.itemWeights[weightIndex].weight
          if (_car.BOM_PART_8 == null) _car.BOM_WEIGHT_8 = null
          weightIndex = (_car.BOM_PART_9) ? this.itemWeights.findIndex(x => x.item.toLowerCase() == currentSystemData.Retainer.toLowerCase()) : -1
          if (weightIndex > -1) _car.BOM_WEIGHT_9 = this.itemWeights[weightIndex].weight
          if (_car.BOM_PART_9 == null) _car.BOM_WEIGHT_9 = null
          this.handleChangeSelect(cn, car, event, 'BOM_PART_2')
          this.handleChangeSelect(cn, car, event, 'BOM_PART_3')
          this.renderCars++
          break
        }
        case 'BOM_PART_5': {
          if (_car[key] !== '' || _car[key] !== null) {
            _car.rope_guard = 'TRUE'
            let bweightIndex = this.itemWeights.findIndex(x => x.item.toLowerCase() === _car[key].toLowerCase())
            if (bweightIndex > -1) {
              _car.BOM_WEIGHT_5 = this.itemWeights[bweightIndex].weight
            } else {
              _car.BOM_WEIGHT_5 = null
            }
          } else {
            _car.rope_guard = null
            _car.BOM_WEIGHT_5 = null
          }
          this.renderCars++
          break
        }
        case 'BOM_PART_2': {
          if (_car[key] !== '' || _car[key] !== null) {
            _car.bedplate = 'TRUE'
          } else {
            _car.bedplate = null
            _car.BOM_WEIGHT_2 = null
          }
          break
        }
        case 'BOM_PART_3': {
          if (_car[key] !== '' || _car[key] !== null) {
            _car.sheave = 'TRUE'
          } else {
            _car.sheave = null
            _car.BOM_WEIGHT_3 = null
          }
          break
        }
        case 'angled_bedplate': {
          if (_car[key] === 'Yes') {
            if (parseFloat(_car['x1']) > parseFloat(_car['x2'])) {
              const radian = Math.asin(parseFloat(_car['x2']) / parseFloat(_car['x1']))
              const degree = radian * (180 / Math.PI)
              const roundedDegree = Math.round((degree + Number.EPSILON) * 100) / 100
               _car['Angle'] = roundedDegree
            } else {
              _car['Angle'] = null
            }
            if (this.handleNaNValues(_car['x1']) && this.handleNaNValues(_car['RDD']) &&
              (parseFloat(_car['x1']) > parseFloat(_car['RDD']) && parseFloat(_car['x1']) > parseFloat(_car['x2']))
            ) {
              _car['RM'] = parseFloat(_car['x1']) - parseFloat(_car['RDD'])
            }
          } else if (_car[key] === 'No') {
            _car['Angle'] = 90
            _car['still_rotation'] = null
            _car['dor'] = null
            _car['x1'] = null
            _car['x2'] = null
            _car['x3'] = null
          }
          this.renderCars++
          break
        }
        case 'x1': {
          if (_car['angled_bedplate'] === 'Yes' &&
            this.handleNaNValues(_car['x1']) && this.handleNaNValues(_car['RDD']) && 
            parseFloat(_car['x1']) > parseFloat(_car['RDD'])
          ) {
            _car['RM'] = parseFloat(_car['x1']) - parseFloat(_car['RDD'])
          }
          this.handleChangeSelect(cn, car, event, 'angled_bedplate')
          if ( parseFloat(_car['x1']) > 0 && parseFloat(_car['x1']) <= parseFloat(_car['RDD']) ) {
            alert('Car Rope Wall (X1) must be larger than Rope Drop Distance');
            _car['x1'] = '';
          }
          if ( parseFloat(_car['x1']) > 0 && parseFloat(_car['x2']) >= parseFloat(_car['x1']) ) {
            alert('Car Rope Wall (X1) must be larger than Car Rope Wall (X2)');
            _car['x1'] = '';
          }
          break
        }
        case 'x2': {
          if ( parseFloat(_car['x2']) > 0 && parseFloat(_car['x2']) >= parseFloat(_car['x1']) ) {
            alert('Car Rope Wall (X2) must be smaller than Car Rope Wall (X1)');
            _car['x2'] = '';
          }
          this.handleChangeSelect(cn, car, event, 'angled_bedplate')
          break
        }
        case 'RDD': {
          if (_car['angled_bedplate'] === 'Yes' && 
            this.handleNaNValues(_car['x1']) && this.handleNaNValues(_car['RDD']) && 
            parseFloat(_car['x1']) > parseFloat(_car['RDD'])
          ) {
            _car['RM'] = parseFloat(_car['x1']) - parseFloat(_car['RDD'])
          }
          if ( parseFloat(_car['RDD']) > 0 && parseFloat(_car['x1']) <= parseFloat(_car['RDD']) ) {
            alert('Rope Drop Distance must be smaller than Car Rope Wall (X1)');
            _car[key] = '';
          }
          if (_car['BT'] === 'Lo') {
            let currentData = {}
            const sysid = parseInt(_car['sysid'])
            const spsysid = parseInt(_car['spsysid'])
            if (!isNaN(sysid) && _car['sysid']) {
              currentData = this.systemData[this.systemData.findIndex(x => x.id == sysid)]
            } else if (!isNaN(spsysid) && _car['spsysid']) {
              currentData = this.specialSystemData[this.specialSystemData.findIndex(x => x.id == spsysid)]
            }
            if (_car.Deflector_Dia == null || _car.Deflector_Dia == '') {
              _car.deflector_bedplate = null
            } else {
              const MSV_ODd = this.machineData[this.machineData.findIndex(x => x.Machine_Part_Number.toLowerCase() == _car['MODEL'].toLowerCase())].MSV_OD
              const defbedd = ((((parseFloat(_car.RDD) - (parseFloat(MSV_ODd) / 2)) - (parseFloat(_car.Deflector_Dia) / 2))) * 25.4) + parseFloat(currentData.Deflector_cen_to_bedplate_cen)
              _car.deflector_bedplate = Math.round((defbedd + Number.EPSILON) * 100) / 100
            }
          }
          this.renderCars++
          break
        }
        case 'Deflector_Dia': {
          this.handleChangeSelect(cn, car, event, 'RDD')
          break
        }
        case 'RG': {
          _car.BOM_PART_4 = _car[key]
          // const weightIndexrg = (_car[key]) ? this.itemWeights.findIndex(x => x.item.toLowerCase() == _car[key].toLowerCase()) : -1
          // if (weightIndexrg > -1) _car.BOM_WEIGHT_4 = this.itemWeights[weightIndexrg].weight
          // if (_car.BOM_PART_4 == null || _car.BOM_PART_4 == '') _car.BOM_WEIGHT_4 = null
          if (_car[key] !== null && _car[key] !== '') {
            const weightIndexrg = (_car[key]) ? this.itemWeights.findIndex(x => x.item.toLowerCase() == _car[key].toLowerCase()) : -1
            if (weightIndexrg > -1) _car.BOM_WEIGHT_4 = this.itemWeights[weightIndexrg].weight
          } else {
            _car.BOM_PART_4 = null
          }
          if (_car.BOM_PART_4 == null) _car.BOM_WEIGHT_4 = null
          this.renderCars++
          break
        }
        case 'EDS': {
          if (_car[key] === 'YES') {
            this.handleChangeSelect(cn, car, event, 'RDD')
          }
          break
        }
        case 'deflector_pn': {
          _car['BOM_PART_3'] = _car[key]
          if (_car['BOM_PART_3'] !== '' || _car['BOM_PART_3'] !== null) {
            _car['sheave'] = 'TRUE'
          }
          this.renderCars++
          break
        }
        case 'MH': {
          let currentDataMh = {}
          const sysid = parseInt(_car['sysid'])
          const spsysid = parseInt(_car['spsysid'])
          if (!isNaN(sysid) && _car['sysid']) {
            currentDataMh = this.systemData[this.systemData.findIndex(x => x.id == sysid)]
          } else if (!isNaN(spsysid) && _car['spsysid']) {
            currentDataMh = this.specialSystemData[this.specialSystemData.findIndex(x => x.id == spsysid)]
          }
          if (_car[key] === 'LEFT' || _car[key] === 'RIGHT') {
            _car.Cbeam_Z1 = this.handleCbeam(_car, currentDataMh, 'cbeamz1')
            _car.Cbeam_Z2 = this.handleCbeam(_car, currentDataMh, 'cbeamz2')
            _car.Cbeam_Z1_Wall = _car.Cbeam_Z1
            _car.Cbeam_Z2_Wall = _car.Cbeam_Z2
          } else {
            _car.Cbeam_Z1 = null
            _car.Cbeam_Z2 = null
            _car.Cbeam_Z1_Wall = _car.Cbeam_Z1
            _car.Cbeam_Z2_Wall = _car.Cbeam_Z2
          }
          this.renderCars++
          break
        }
        case 'Wf':
        case 'Z1':
        case 'Z2': {
          this.handleChangeSelect(cn, car, event, 'MH')
          break
        }
      }
    },
    handleNaNValues(value) {
      return !isNaN(parseFloat(value))
    },
    handleCbeam(car, systemDatac, key) {
      const maxz1 = parseFloat(systemDatac.MaxZ1L)
      const maxz2 = parseFloat(systemDatac.MaxZ2L)
      const mh = car.MH
      const wf = parseFloat(car.Wf)
      const z1 = parseFloat(car.Z1)
      const z2 = parseFloat(car.Z2)
      if (isNaN(wf) || isNaN(z1) || isNaN(z2)) return null
      if (key === 'cbeamz1') {
        if (mh === 'LEFT') {
          const lchecker = z1 + 0.5 * wf
          if (lchecker > maxz1) {
            return lchecker
          }
        } else if (mh === 'RIGHT') {
          const rchecker = z2 + 0.5 * wf
          if (rchecker > maxz1) {
            return z1 + 0.5 * wf
          }
        }
        return maxz1
      } else if (key === 'cbeamz2') {
        if (mh === 'LEFT') {
          const lchecker2 = z2 + 0.5 * wf
          if (lchecker2 > maxz2) {
            return lchecker2
          }
        } else if (mh === 'RIGHT') {
          const rchecker2 = z1 + 0.5 * wf
          if (rchecker2 > maxz2) {
            return z2 + 0.5 * wf
          }
        }
        return maxz2
      }
    },
    handleNotApplicableOrNullValue(data) {
      if (data == 'NA' || data == 'N/A' || data == null || data == '') {
        return null
      }
      return data
    },
    handleClickedMachine(event, car, cn) {
      const tempModel = event.value
      const tempInd = this.machineData.findIndex(x => x.option.toLowerCase() === tempModel.toLowerCase())
      let _cart = this.drawingParams[cn]
      const targetEvent = {
        target: {
          value: tempModel,
          selectedIndex: tempInd
        }
      }
      _cart.MODEL = tempModel
      _cart.search = event.search_key
      if (
          tempModel !== null &&
          tempModel !== undefined &&
          tempModel !== '' &&
          !(tempModel.trim && tempModel.trim() == '')
        ) {
        this.handleChangeSelect(cn, car, targetEvent, 'MODEL')
        }
    }
  }
}
</script>
<style scoped>
  .f-subwrap:hover, .f-subwrap:focus { z-index: 2 !important; }
  .f-sublist { display: none; position: absolute; top: 100%; left: 0px; width: 100%; max-height: 300px; overflow: auto; margin: 0; padding: 0; }
  .f-sublist li { display: block; background: #FFF; padding: 0 4px; line-height: 14px; }
  .f-sublist li:hover { background: #0075ff; color: #fff; }
  .f-sub:focus + .f-sublist, .f-sublist.f-show { display: block !important; }
  .selform { padding: 0px 15px 15px; height: calc(100vh - 370px); }
  .selection-car { margin-top: 15px; }
  .selform .selection-car .btn { display: inline-block; width: 200px; color: #FFF;  }
  .car-items,
  .car-selection { border: 1px solid #000; height: calc(100vh - 385px); min-height: 300px; padding: 10px; background: #FFF; }
  .car-items { margin-left: -15px; }
  .car-item-list { overflow-y: auto; overflow-x: hidden; height: calc(100vh - 450px); min-height: 240px; }
  .sel-item-qty { width: 50px; margin: -3px 0 0 4px; border-radius: 0; border: 1px solid #000; }
  .car-item.car-item-head { font-weight: bold; text-transform: uppercase; font-size: 12px; margin-top: -2px; min-height: 14px; }
  .car-item-head label { display: inline-block; width: 194px; }
  .car-item-head .car-item { width: 194px; min-height: 14px; }
  .car-item-head .car-price { width: 22%; }
  .car-item-head .car-qty { width: 12%; }
  .car-items h3,
  .car-selection h3 { background: #000; color: #FFF; font-size: 13px; text-transform: uppercase; padding: 10px; margin: -10px -10px 10px; }
  .car-selection label { width: 100px; }
  .car-item label { display: inline-block; width: 174px; overflow: hidden; text-overflow: ellipsis; }
  .project-form .car-selection select, .project-form .sel-filter > input { min-width: 200px; padding: 6px; text-align: left; text-align-last: left; }
  .project-form .car-selection > select, .project-form .sel-filter > input { width: calc(50% - 5px); float: left; margin: 0 0 10px; }
  .project-form .sel-filter > input { margin-left: 10px; }
  .car-item,
  .selection_items { clear: both; height: calc(100vh - 490px); min-height: 200px; overflow: auto; list-style: none; padding: 0px; }
  .selection_items > li { padding: 4px; border: 1px solid #000; position: relative; margin-top: 6px; }
  .selection_items span { float: right; margin-right: 78px; }
  .selection_items a { background: green; color: #FFF; text-transform: uppercase; cursor: pointer; display: inline-block; padding: 4px 10px; position: absolute; top: 0px; right: 0;}
  .sel-filter > div { margin-top: 4px; }
  .car-item { margin-top: 4px; height: 16px; min-height: 16px; position: relative; overflow: visible; }
  .car-item span { float: right; margin-right: 20px; }
  .car-item a { position: absolute; top: -5px; right: -4px; padding: 0px 6px; font-size: 20px; line-height: 26px; cursor: pointer; opacity: 0; }
  .car-item:hover a { opacity: 1; }
  .car-item a:hover { color: red; }

  .ses-content .form-control { color: #333; }
  .ses-content .fx-datasheet { z-index: 1000; padding-bottom: 90px; }
  .ses-content .fx-datasheet.is_loading { z-index: 99999; }
  table { width: 1000px; margin: 0 auto; }
  table th,
  table td { width: 25%; border: 1px solid #333; }
  .form-wrap { margin-bottom: 40px; color: #000; max-width: 768px; }
  .project-form { font-family: "Arial", sans-serif; font-size: 12px; font-weight: 300; }
  .project-details { width: 880px; }
  .project-form input[type="text"], .project-form input[type="number"], .project-form input[type="email"],
  .project-form select { text-align: center; text-align-last: center; }
  .proj-set {float: left;border: 1px solid #333;width: 400px;box-sizing: border-box;margin-top: -1px;}
  .proj-set-lg { width: 481px; margin-right: -1px; }
  .proj-set-location,
  .proj-set-full { width: 880px; }
  .proj-set label strong { font-size: 13px; text-transform: uppercase; }
  .proj-set label,
  .proj-set input,
  .proj-set select { width: 198px; padding-left: 3px; display: block; float: left; height: 27px; line-height: 27px; margin: 0px; box-sizing: border-box; border: none !important; outline: 1px solid #333; outline-offset: 0px; background: #FFF; }
  .proj-car input[type=number], .proj-car input[type=text], .proj-car select { background: #FFF; }
  .proj-set label { font-weight: 300; width: 200px; margin-right: -1px; }
  .proj-set-full label,
  .proj-set-location label,
  .proj-set-lg label { width: 280px; }
  .proj-set-lg input { width: 199px; }
  .proj-set select { width: 198px; }
  .project-form [disabled],
  .project-form [readonly] { background: #eee !important; opacity: 1; }
  .proj-set-full input { width: 598px; }
  .proj-set-full .select-full { width: 598px; }
  .form_type { margin-left: -1px; }
  .form_type input { width: 14px; margin-right: 10px; outline: none; }
  .form_type label { border: none; outline: none; width: auto; margin-right: 30px; }
  .project-details:after,
  .project-section:after,
  .proj-cars:after,
  .proj-split:after,
  .proj-set:after,
  .top-scroll:after { content: " "; display: block; clear: both; }
  .top-scroll:before { content: " "; display: block; clear: both; }
  .ind { display: inline-block; width: 10px; height: 13px; }

  .project-section { width: 880px; white-space: nowrap; border: 1px solid #333; }
  .project-form .project-section h2 { font-size: 14px; font-weight: bold; height: 27px; line-height: 27px; margin: 0px; width: 100%; text-align: center; text-transform: none; }
  .project-section label { font-weight: 300; margin: 0px; }
  .proj-labels { background: #FFF; }
  .proj-labels,
  .proj-car { width: 280px; float: left; white-space: normal; }
  .proj-cars { white-space: nowrap; overflow: auto; margin-left: 281px; border-top: 1px solid #333; letter-spacing: 0px; background: #EEE; }
  .top-scroll { white-space: nowrap; overflow: auto; margin-left: 281px; border: 0; letter-spacing: 0px; }
  .proj-car { width: 200px; margin-top: -1px; float: none; display: inline-block; position: relative; z-index: 1; background: #FFF; }
  .proj-car .btn-primary { color: #fff; background: #337ab7; border-color: #2e6da4; }
  .proj-car .btn-success { color: #fff; background: #5cb85c; border-color: #5cb85c; }
  .proj-car .btn-danger { color: #fff; background: #d9534f; border-color: #d9534f; }
  .proj-car .proj-group > div,
  .proj-labels .proj-group > div { display: block; display: flex; box-sizing: border-box; outline: 1px solid #333; outline-offset: 0px; height: 27px; margin-top: 1px; width: 100%; line-height: 27px; }
  .proj-labels .proj-group > div.proj-r2 { height:  55px; height: calc(28px * 2px - 1px); }
  .proj-labels .proj-group > div.proj-r3 { height:  83px; height: calc(28px * 3px - 1px); }
  .proj-labels .proj-group > div.proj-r4 { height: 111px; height: calc(28px * 4px - 1px); }
  .proj-labels .proj-group > div.proj-r5 { height: 139px; height: calc(28px * 5px - 1px); }
  .proj-labels .proj-group > div.proj-r6 { height: 167px; height: calc(28px * 6px - 1px); }
  .proj-labels .proj-group > div.proj-h2 {width: 878px;text-align: center;background: #FFF;z-index: 10;position: relative;}
  .proj-labels .proj-group > div.proj-h3 {width: 878px;text-align: left;background: #FFF;z-index: 10;position: relative;}
  .proj-labels .proj-group > div.proj-h2 label {width:100%;}
  .proj-labels .proj-group > div.proj-h2-field {padding:0px;}
  .proj-labels .proj-group > div.proj-h2-field label {padding-left:3px;width:281px;text-align:left;outline: 1px solid #333; outline-offset: 0px;height:27px;line-height:27px;}
  .proj-labels .proj-group > div.proj-h2-field select,
  .proj-labels .proj-group > div.proj-h2-field input {width:calc(100% - 280px);outline: 1px solid #333; outline-offset: 0px;border:0px;}
  .project-form label { background: #FFF; }
  .proj-car label,
  .proj-labels .proj-group > div { padding-left: 3px; }
  .proj-car label { font-size: 11px; margin: 0px; }
  .proj-car label input[type="checkbox"]{ float: left; margin: 0 3px 0 0; }
  .proj-labels .proj-group > div { position: relative; }
  .proj-car label,
  .proj-labels .proj-group > div label { line-height: 12px; place-self: center; }
  .proj-car input[type="text"], .proj-car input[type="number"],
  .proj-car select { width: 100%; display: block; height: 27px; line-height: 27px; margin: 0px; box-sizing: border-box; border: none !important; outline: 1px solid #333; outline-offset: 0px; padding-left: 3px; place-self: center; text-align: center; text-align-last: center; }
  .proj-car .proj-split { width: 100%; display: flex; }
  .proj-car .proj-split > select,
  .proj-car .proj-split > label,
  .proj-car .proj-split > div,
  .proj-car .proj-split > input { float: left; width: 50%; place-self: center; text-align: center; }
  .proj-car .proj-split.split-2-1 > div { width: 67%; text-align: left; }
  .proj-car .proj-split.split-2-1 > div label { display: block; text-align: left; }
  .proj-car .proj-split.split-2-1 > select { width: 33%; }
  .proj-car .btn-fl,
  .proj-split .btn { width: 33.33%; border-radius: 0px; text-transform: uppercase; line-height: 27px; padding: 0px 0px; font-size: 11px; display: inline-block; margin: 0px; }
  .proj-car .btn-fl { width: 100%; color: #337ab7 !important; }
  .proj-car .proj-split > label.proj-chk { text-align: left; line-height: 14px; font-size: 10px; }
  .proj-car .proj-group>div, .proj-labels .proj-group>div { z-index: 1; position: relative; background: #FFF; }
  .proj-labels .proj-group>div { border-right: 1px solid #000; }
  .proj-labels .proj-group>div:hover { z-index: 9999; }

  .checkbox-list { border-left: 1px solid #000; }
  .checkbox-list label { display: block; clear: both; margin: 8px 0; }

  .ie-wrap .proj-split .btn { float: left; margin-right: -1px; height: 27px; }
  .ie-wrap .proj-labels .proj-group > div.proj-h2-field label { float: left; }
  .ie-wrap .proj-labels .proj-group > div.proj-h2-field select { margin-left: 280px; display: block; height: 27px; line-height: 27px; box-sizing: border-box;width:calc(100% - 282px); border-left: none; }

  .hide-copy .js-copy-col1,
  [data-cn="1"] .js-copy-col1 { display: none; }

  .static-cover-wrap { position: relative; }
  .static-cover { position: absolute; top: 0px; left: 0px; width: 100%; height: 100%; background: transparent; z-index: 2; display: block; }

  .proj-labels .mx-datepicker { width: calc(100% - 280px); }
  .proj-labels .mx-datepicker .mx-input-wrapper .mx-input { width: 100%; padding: 0px; height: 27px; border-radius: 0; }

  .proj-set-full { position: relative; }
  .ses-content .btn-remove { position: absolute; top: 2px; right: 2px; cursor: pointer; background: red; color: #FFF; padding: 0px 9px; font-size: 20px; line-height: 21px; }
  .ses-content .btn-caradd { padding: 4px 16px; margin: 10px 0 0; }
  .project-cars-wrap { width: 880px; }
  .proj-set-full .col { padding: 0px; }
  
  .proj-error,
  .proj-car input:focus,
  .proj-set input:focus { outline-color: blue; z-index: 1; position: relative; }
  .proj-car select:focus,
  .proj-set select:focus { outline-color: blue; z-index: 1; }
  .project-form .has-error{ outline: 1px solid red !important; z-index: 2 !important; background: #ffe9e9 !important; border-color: red !important; }
  .proj-error { outline: 1px solid red !important; }
  .proj-set { white-space: nowrap; }
  .proj-set .proj-address { width: 400px; }
  .proj-set .proj-zip { width: 199px; margin-left: 2px; }
  .proj-set-location .proj-label-lg { height: 54px; line-height: 54px; }
  .proj-flex { white-space: nowrap; }
  .proj-flex > div { display: inline-flex; }

  .progress-bar-animated { -webkit-animation: progress-bar-stripes 1s linear infinite; animation: progress-bar-stripes 1s linear infinite; }

  .show-datasheet { overflow: hidden; }
  .show-datasheet .btn-clc,
  .btn-rqt { display: none !important; }
  .show-datasheet .btn-rqt { display: inline-block !important; }
  .show-datasheet.show-review-1 .js-calculate { display: inline-block !important; }
  .show-datasheet.show-review-1 .js-request { display: none !important; }

  .warning { color: red; padding: 10px 20px 0px; font-size: 14px; }
  .hlight label { color: #F00 !important; }

  .sform .mx-datepicker input { border-radius: 0; height: 27px; box-sizing: border-box; border: none!important; outline: 1px solid #333; outline-offset: 0; }

  input:-webkit-autofill, select:-webkit-autofill { background-color: #FFF !important; }

  .proj-labels .proj-group>div.proj-h2-field label.rb2 { border-right: 2px solid #000; width: 282px; }

  .ses-project { border: 1px solid #000; width: 880px; }
  .ses-project .static { background: #eee; text-align: center; }
  .ses-project td { padding: 3px 3px; }
  .ses-project strong { text-transform: uppercase; }
  .ses-project input,
  .ses-project select { width: 100%; margin: -4px -4px; height: 17px; display: block; box-sizing: content-box; }
  .ses-project select { padding: 2px 3px; }
  .ses-project .ses-flex-wrap { padding: 0px; }
  .ses-flex { display: flex; width: 100%; flex-wrap: wrap; overflow: hidden; width: calc(100% + 1px); }
  .ses-col { -ms-flex-preferred-size: 0; flex-basis: 0; -webkit-box-flex: 1; -ms-flex-positive: 1; flex-grow: 1; padding: 3px 0 3px 0px; overflow: hidden; border-right: 1px solid #000; }
  .ses-col input { padding: 1px; }
  .ses-project label { margin: 0 20px 0 0; padding: 0px 8px; }
  .ses-project input[type="radio"] { width: 14px; height: 14px; display: inline-block; margin: 0px 4px 0 0; border: none; float: left; }

  .invi-cover { position: absolute; top: 0px; left: 0px; width: 100%; height: 100%; z-index: 10; background: #000; opacity: .2; }

  .fx-datasheet .project-section { font-size: 12px; text-align: left; margin: 0 auto; }
  .fx-datasheet .proj-car .proj-group > div { text-align: center !important; text-align-last: center; display: block; overflow: hidden; }
  .fx-datasheet .proj-car .proj-group > div label { float: left; margin: 5px 0 0 2px; }
  .fx-datasheet h2 { margin: 0; font-size: 15px; text-align: center; margin: 0 auto; max-width: 880px; }
  .fx-datasheet h2.text-left {
      text-align: left;
      margin-top: 15px;
      font-size: 14px;
      text-transform: uppercase;
      background: #333;
      color: #FFF;
      font-weight: normal;
      padding: 3px 4px 1px;
  }
  @media (max-width: 768px) {
      .form-wrap {
          overflow-y: auto;
      }
      .project-section, .sform {
          min-width: 620px;
      }
  }
  @media (max-width: 1220px) {
      .form-wrap {
          overflow-y: hidden;
      }
      .project-section, .sform {
          width: 100%;
      }
  }

  .phone-wrap {
      display: flex;
      align-items: center;
  }
  .phone-wrap::v-deep input {
      border: 0;
  }
  .phone-wrap::v-deep input:first-child {
      margin-right: 5px;
      text-align: right;
      width: 50%;
  }

  .start_date_wrap {
      width: calc(100% - 280px);
  }
  .start_date_wrap .mx-datepicker {
      width: 100%;
  }
  .start_date_wrap.has-error .mx-datepicker::v-deep .mx-input {
      outline: 1px solid red !important; z-index: 2 !important; background: #ffe9e9 !important; border-color: red !important;
  }

  .name-wrap {
      display: flex;
      align-items: center;
      margin: -4px 0;
  }
  .name-wrap .dropdown {
      width: 22px;
  }
  .name-wrap::v-deep .dropdown .nav-link {
      padding-left: 8px !important;
  }
  .name-wrap::v-deep .dropdown .dropdown-menu {
      max-height: 200px;
      overflow: auto;
  }
  .name-wrap::v-deep .dropdown .dropdown-menu .dropdown-item {
      font-size: 14px;
      padding: .3rem 0.5rem;
      cursor: pointer;
  }
  .top-scroll-body {
      height: 1px;
  }
  .project-section-1 {
    margin-top: 5px !important;
  }
  .btn-custom-height {
    height: 40px !important;
    padding: 10px 20px !important;
  }
  .btn-custom-height:hover {
    color: white !important;
  }
  .btn-custom-height:focus {
    color: white !important;
  }
  .project-details {
    width: 880px !important;
  }
  .model-param-label {
    min-height: 54px !important;
    max-height: 54px !important;
  }
  .model-param {
    position: unset !important;
    min-height: 54px;
    max-height: 54px;
  }
</style>
